export const getBase64FileSize = (base64EncodedFile: string): number | null => {
    const base64content = base64EncodedFile.split(',')[1];

    if (!base64content.length) return null;

    return base64content.length * 3 / 4 - (base64content.match('"') || []).length;
}
